import { render, staticRenderFns } from "./BaoduSuccess.vue?vue&type=template&id=61003186&scoped=true"
import script from "./BaoduSuccess.vue?vue&type=script&lang=js"
export * from "./BaoduSuccess.vue?vue&type=script&lang=js"
import style0 from "./BaoduSuccess.vue?vue&type=style&index=0&id=61003186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61003186",
  null
  
)

export default component.exports